import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-admin';
import { FieldProps } from '../../types';

/**
 * Component to display an invoice field in the charge list with a link to the invoice's detail page
 * Uses the embedded invoice object from the charge API response
 */
const ChargeInvoiceField: React.FC<FieldProps<any>> = ({
    record,
    link = 'show',
}) => {
    if (!record) return null;

    // Handle both nested invoice object and direct invoiceId
    const invoiceId = record.invoice?.id || record.invoiceId;

    if (!invoiceId) return <span>-</span>;

    return link ? (
        <Link to={`/invoices/${invoiceId}/show`}>{invoiceId}</Link>
    ) : (
        <span>{invoiceId}</span>
    );
};

ChargeInvoiceField.propTypes = {
    record: PropTypes.object,
    link: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    label: PropTypes.string,
};

ChargeInvoiceField.defaultProps = {
    addLabel: true,
    label: 'Invoice',
};

export default ChargeInvoiceField;
